var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    transform: "translate(-63.000000, -193.000000)",
    fillRule: "nonzero",
    fill: "#67BFB5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-icon",
    transform: "translate(63.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17072851,10.8632352 C3.74717647,10.8632352 1.77593213,8.84391738 1.77593213,6.36126127 C1.77593213,3.87860517 3.74717647,1.85928736 6.17072851,1.85928736 C8.59428054,1.85928736 10.5655249,3.87860517 10.5655249,6.36126127 C10.5655249,8.84391738 8.59428054,10.8632352 6.17072851,10.8632352 M6.17072851,0.642537648 C3.09247059,0.642537648 0.588149321,3.20793273 0.588149321,6.36126127 C0.588149321,9.51458982 3.09247059,12.0799849 6.17072851,12.0799849 C9.24898643,12.0799849 11.7533077,9.51458982 11.7533077,6.36126127 C11.7533077,3.20793273 9.24898643,0.642537648 6.17072851,0.642537648",
    id: "Fill-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02140724,5.75288642 L6.76461991,5.75288642 L6.76461991,3.44106198 C6.76461991,3.10523906 6.49855656,2.83268712 6.17072851,2.83268712 C5.84290045,2.83268712 5.5768371,3.10523906 5.5768371,3.44106198 L5.5768371,5.75288642 L3.32004977,5.75288642 C2.99222172,5.75288642 2.72615837,6.02543836 2.72615837,6.36126127 C2.72615837,6.69708419 2.99222172,6.96963613 3.32004977,6.96963613 L5.5768371,6.96963613 L5.5768371,9.28146057 C5.5768371,9.61728349 5.84290045,9.88983543 6.17072851,9.88983543 C6.49855656,9.88983543 6.76461991,9.61728349 6.76461991,9.28146057 L6.76461991,6.96963613 L9.02140724,6.96963613 C9.34923529,6.96963613 9.61529864,6.69708419 9.61529864,6.36126127 C9.61529864,6.02543836 9.34923529,5.75288642 9.02140724,5.75288642",
    id: "Fill-75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.f78d2b4f7381271a245d8b67ca06bc3d.svg";
export { ForwardRef as ReactComponent };